import React, { useState, useEffect } from 'react';
import { FaStar } from 'react-icons/fa';
import { useAuth } from '../../context/AuthContext';

const RatingForm = () => {
  const [showForm, setShowForm] = useState(false);
  const [description, setDescription] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const { user, token } = useAuth();

  useEffect(() => {
     if (user) {
       const hasRated = localStorage.getItem(`hasRated_${user._id || user.username}`);
      if (!hasRated) {
         const timer = setTimeout(() => {
          setShowForm(true);
        }, 2000);
        
        return () => clearTimeout(timer);
      }
    }
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!description.trim()) {
      setError('يرجى كتابة تقييمك للمنصة');
      return;
    }

    setIsSubmitting(true);
    setError('');
    
    try {
      const response = await fetch('https://question-manager-backend.onrender.com/api/rating', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ description })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'حدث خطأ أثناء إرسال التقييم');
      }

       localStorage.setItem(`hasRated_${user._id || user.username}`, 'true');
      
       setSuccess(true);
      setTimeout(() => {
        setShowForm(false);
      }, 3000);
      
    } catch (err) {
      setError(err.message || 'حدث خطأ أثناء إرسال التقييم');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setShowForm(false);
  };

  if (!showForm) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" dir="rtl">
      <div className="bg-white rounded-lg shadow-lg max-w-md w-full p-6 relative">
        <button 
          onClick={handleClose}
          className="absolute top-2 left-2 text-gray-500 hover:text-gray-700"
        >
          &times;
        </button>
        
        <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">شاركنا رأيك في المنصة</h3>
        
        {success ? (
          <div className="text-center p-4">
            <div className="flex justify-center mb-4">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center text-green-600">
                <FaStar className="text-2xl" />
              </div>
            </div>
            <p className="text-green-600 font-medium">تم إرسال تقييمك بنجاح، شكراً لمشاركتك!</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-1">
                تقييمك للمنصة
              </label>
              <textarea
                id="description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                rows="4"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#320A6B]"
                placeholder="اكتب رأيك في المنصة التعليمية..."
              />
              {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
            </div>
            
            <div className="flex items-center justify-between mt-4">
              <button
                type="button"
                onClick={handleClose}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-300"
              >
                إغلاق
              </button>
              <button
                type="submit"
                disabled={isSubmitting}
                className={`px-4 py-2 text-sm font-medium text-white bg-[#320A6B] rounded-md hover:bg-[#2a095a] focus:outline-none focus:ring-2 focus:ring-[#320A6B] ${
                  isSubmitting ? 'opacity-70 cursor-not-allowed' : ''
                }`}
              >
                {isSubmitting ? 'جاري الإرسال...' : 'إرسال التقييم'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default RatingForm;